/**
 * @generated SignedSource<<366f331668321326290e0f8c0c3ae6d9>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type DashboardsContentRefactored$data = {
  readonly dashboardOrder: {
    readonly sidebar: {
      readonly nodes: ReadonlyArray<{
        readonly menuId: string | null | undefined;
        readonly visible: boolean | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly jira: {
    readonly dashboardFavourites: {
      readonly __id: string;
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly dashboardId?: AGG$Long;
          readonly id?: string;
          readonly title?: string;
          readonly " $fragmentSpreads": FragmentRefs<"DashboardMenuItemRefactored">;
        };
      } | null | undefined> | null | undefined;
      readonly pageInfo: {
        readonly hasNextPage: boolean;
      };
    };
    readonly dashboardRecents: {
      readonly __id: string;
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly dashboardId?: AGG$Long | null | undefined;
          readonly id?: string;
          readonly " $fragmentSpreads": FragmentRefs<"DashboardMenuItemRefactored">;
        };
      } | null | undefined> | null | undefined;
    };
  };
  readonly " $fragmentType": "DashboardsContentRefactored";
};
export type DashboardsContentRefactored$key = {
  readonly " $data"?: DashboardsContentRefactored$data;
  readonly " $fragmentSpreads": FragmentRefs<"DashboardsContentRefactored">;
};

import Nav4DashboardsContentRefactoredQuery_graphql from './Nav4DashboardsContentRefactoredQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v1 = {
  "kind": "ScalarField",
  "name": "id"
},
v2 = {
  "kind": "ScalarField",
  "name": "dashboardId"
},
v3 = {
  "kind": "FragmentSpread",
  "name": "DashboardMenuItemRefactored"
},
v4 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "cloudId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "currentURL"
    },
    {
      "kind": "RootArgument",
      "name": "entityAri"
    },
    {
      "kind": "RootArgument",
      "name": "ownerAri"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "fragmentPathInResult": [],
      "operation": Nav4DashboardsContentRefactoredQuery_graphql
    }
  },
  "name": "DashboardsContentRefactored",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": {
              "alias": "dashboardFavourites",
              "args": [
                (v0/*: any*/),
                {
                  "kind": "Literal",
                  "name": "filter",
                  "value": {
                    "sort": {
                      "order": "DESC"
                    },
                    "type": "DASHBOARD"
                  }
                },
                {
                  "kind": "Literal",
                  "name": "first",
                  "value": 15
                }
              ],
              "concreteType": "JiraFavouriteConnection",
              "kind": "LinkedField",
              "name": "favourites",
              "plural": false,
              "selections": [
                {
                  "concreteType": "PageInfo",
                  "kind": "LinkedField",
                  "name": "pageInfo",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "hasNextPage"
                    }
                  ]
                },
                {
                  "concreteType": "JiraFavouriteEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "RequiredField",
                      "field": {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "kind": "RequiredField",
                                "field": (v1/*: any*/),
                                "action": "THROW",
                                "path": "jira.dashboardFavourites.edges.node.id"
                              },
                              {
                                "kind": "RequiredField",
                                "field": {
                                  "kind": "ScalarField",
                                  "name": "title"
                                },
                                "action": "THROW",
                                "path": "jira.dashboardFavourites.edges.node.title"
                              },
                              {
                                "kind": "RequiredField",
                                "field": (v2/*: any*/),
                                "action": "THROW",
                                "path": "jira.dashboardFavourites.edges.node.dashboardId"
                              },
                              (v3/*: any*/)
                            ],
                            "type": "JiraDashboard"
                          }
                        ]
                      },
                      "action": "THROW",
                      "path": "jira.dashboardFavourites.edges.node"
                    }
                  ]
                },
                (v4/*: any*/)
              ]
            },
            "action": "THROW",
            "path": "jira.dashboardFavourites"
          },
          {
            "kind": "RequiredField",
            "field": {
              "alias": "dashboardRecents",
              "args": [
                (v0/*: any*/),
                {
                  "kind": "Variable",
                  "name": "currentURL",
                  "variableName": "currentURL"
                },
                {
                  "kind": "Literal",
                  "name": "first",
                  "value": 20
                },
                {
                  "kind": "Literal",
                  "name": "types",
                  "value": [
                    "DASHBOARD"
                  ]
                }
              ],
              "concreteType": "JiraSearchableEntityConnection",
              "kind": "LinkedField",
              "name": "recentItems",
              "plural": false,
              "selections": [
                {
                  "concreteType": "JiraSearchableEntityEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "RequiredField",
                      "field": {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "kind": "RequiredField",
                                "field": (v1/*: any*/),
                                "action": "THROW",
                                "path": "jira.dashboardRecents.edges.node.id"
                              },
                              (v2/*: any*/),
                              (v3/*: any*/)
                            ],
                            "type": "JiraDashboard"
                          }
                        ]
                      },
                      "action": "THROW",
                      "path": "jira.dashboardRecents.edges.node"
                    }
                  ]
                },
                (v4/*: any*/)
              ]
            },
            "action": "THROW",
            "path": "jira.dashboardRecents"
          }
        ]
      },
      "action": "THROW",
      "path": "jira"
    },
    {
      "alias": "dashboardOrder",
      "args": [
        {
          "kind": "Variable",
          "name": "entityAri",
          "variableName": "entityAri"
        },
        {
          "kind": "Variable",
          "name": "ownerAri",
          "variableName": "ownerAri"
        }
      ],
      "concreteType": "SettingsNavigationCustomisation",
      "kind": "LinkedField",
      "name": "settings_navigationCustomisation",
      "plural": false,
      "selections": [
        {
          "concreteType": "SettingsMenuItemConnection",
          "kind": "LinkedField",
          "name": "sidebar",
          "plural": false,
          "selections": [
            {
              "concreteType": "SettingsMenuItem",
              "kind": "LinkedField",
              "name": "nodes",
              "plural": true,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "menuId"
                },
                {
                  "kind": "ScalarField",
                  "name": "visible"
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "Query"
};
})();

(node as any).hash = "ae6830494fafa0893401f12ba570e85a";

export default node;
